import {  createAction } from '@reduxjs/toolkit';

//Global redux actions
export const registrationCreated = createAction<number | undefined>('registration/created');
export const clearUser = createAction<number | undefined>('user/clear');
